import * as React from 'react';
import './search.scss';
import { Search as SearchIcon } from 'rcd-cpp-ui/ui/icon';
import { cn, getSchema } from '../../../utils';
import { useSelector } from '../../../utils/useSelector';
import { NodeType } from '../../../enums/NodeType';
import { View } from '../../../types/View';
import { Op } from '../../../enums/Op';
import { useActions } from '../../View/viewActions';
import { useNavigate } from 'react-router-dom';
import URLManager from '../../../utils/urlManager';
import { findOne } from 'rcd-cpp-workspace/utils/array';
import { useFullStory } from '../../App/fullStory';
import { FSEvent } from '../../../enums/FSEvent';

export const Search = () => {
  const wid = useSelector(s => s.planning?.selectedWorkspace?.props?.refId);
  const vid = useSelector(s => s.view?.selected?.props?.refId);
  const curFilters = useSelector(s => s.view?.filters);
  const itemSchemaRefId = useSelector(s => {
    const itemSchema = getSchema(
      s.planning?.selectedWorkspace?.schemas,
      NodeType.Item
    );
    return itemSchema?.props?.refId;
  });
  const [expanded, setExpanded] = React.useState(false);
  const [value, setValue] = React.useState('');
  const ref = React.useRef(null);
  const { setViewSettings, setFilters } = useActions();
  const navigate = useNavigate();
  const { captureEvent } = useFullStory();
  const handleSearch = React.useCallback(() => {
    const s = value.trim();
    if (!!s) {
      const filters: View.FiltersField[] = [];
      if (isNumeric(s)) {
        filters.push({
          field: 'Item.itemId',
          conditions: [{ [Op.equals]: parseInt(s) }]
        });
      } else {
        filters.push({
          field: 'Item.title',
          conditions: [{ [Op.contains]: s }]
        });
      }
      if (vid == itemSchemaRefId) {
        curFilters?.forEach(f => {
          if (!findOne(filters, { field: f.field })) {
            filters.push({ field: f.field });
          }
        });
        setFilters(filters);
      } else {
        setViewSettings({ filters }, itemSchemaRefId);
        navigate(URLManager.generateUrl(wid, { v: itemSchemaRefId }));
      }
      captureEvent(FSEvent.Search);
    }
  }, [value, vid, wid, curFilters]);
  if (!wid) return null;
  return (
    <div
      className={cn('header-search', { 'header-search--expanded': expanded })}
    >
      <span
        onClick={() => {
          if (expanded) {
            handleSearch();
          } else {
            setExpanded(true);
            if (ref.current) {
              ref.current.focus();
            }
          }
        }}
      >
        <SearchIcon />
      </span>
      <input
        ref={ref}
        type="text"
        className="form-control"
        placeholder="Search on title or item ID"
        value={value}
        onChange={e => setValue(e.target.value)}
        onBlur={() => {
          if (!value.trim()) setExpanded(false);
        }}
        onFocus={() => setExpanded(true)}
        onKeyUp={e => {
          if (e.key == 'Enter') handleSearch();
        }}
      />
    </div>
  );
};

const isNumeric = (value: string) => /^\d+$/.test(value);
